import { createFileRoute } from "@tanstack/react-router";
import { PackMarketPage } from "@client/components/settings/industry-pack/pack-market-page";

export const Route = createFileRoute(
  "/_app/tenant-settings/industry-packs/",
)({
  component: PackMarketPage,
});
